import { connect } from 'react-redux';
import { fetchWrapupsIfNeeded, toggleApproveModal, advanceRequest } from 'project/ducks/wrapup';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import ApproveModal from 'project/components/wrapup/approve_modal';

export default connect(() => ({}), {
  fetchWrapupsIfNeeded,
  fetchMessagesIfNeeded,
  onClose: toggleApproveModal,
  approveRequest: advanceRequest
})(ApproveModal);



// WEBPACK FOOTER //
// ./project/containers/wrapup/approve_modal.js